import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var DigitalTranslationUploadButton = function DigitalTranslationUploadButton(_ref) {
  var hasFile = _ref.hasFile,
    onClick = _ref.onClick,
    isDragActive = _ref.isDragActive,
    disabled = _ref.disabled,
    onDragStatusChanged = _ref.onDragStatusChanged;
  useEffect(function () {
    onDragStatusChanged(isDragActive);
  }, [isDragActive]);
  if (hasFile) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "me-0 w-100"
  }, /*#__PURE__*/React.createElement("button", {
    className: "digital-translations-upload-button text-start w-100 mt-1  border-0 d-block text-dark ".concat(isDragActive ? 'hovered' : ''),
    disabled: disabled,
    onClick: onClick,
    type: "button"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "text me-2",
    icon: "fa-solid fa-file-lines"
  }), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-editing-file-upload-text"
  })));
};
export default DigitalTranslationUploadButton;